import { useState } from "react"


export const Approver = () => {
    const [publicationList, setPublicationList] = useState([])
    const [openSnackbar, setOpenSnackbar] = useState({toggled: false, msg: ''})

    const [bulletinList, setBulletinList] = useState([])

    return {
        publicationList: { data: publicationList, set: setPublicationList },
        openSnackbar: { data: openSnackbar, set: setOpenSnackbar },

        bulletinList: {data: bulletinList, set: setBulletinList}
    }
}